import React from "react";
import { 
  FaFacebook, FaTwitter, FaGithub, FaDiscord, 
  FaHome, FaUser, FaServer, FaHandshake, FaNetworkWired, 
  FaBook, FaGlobe, FaFileAlt, FaYoutube 
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-400 py-6 px-4">
      <div className="container mx-auto flex flex-col lg:flex-row items-center justify-between">
        <div className="max-w-md text-center lg:text-left mb-4 lg:mb-0">
          <h2 className="text-white text-lg font-semibold">About Menelik</h2>
          <p className="text-sm">
            Menelik is an innovative blockchain solution designed to offer the best staking and mining experiences for crypto enthusiasts. 
            Whether you are a miner or interested in staking your coins, Menelik has you covered.
          </p>
        </div>

        <ul className="flex flex-col lg:flex-row space-y-2 lg:space-y-0 lg:space-x-4 text-sm">
          <li>
            <a href="/" className="hover:underline flex items-center">
              <FaHome className="mr-1" /> Home
            </a>
          </li>
          <li>
            <a href="/top-addresses" className="hover:underline flex items-center">
              <FaUser className="mr-1" /> Holders
            </a>
          </li>
          <li>
            <a href="/smartnodes" className="hover:underline flex items-center">
              <FaServer className="mr-1" /> SmartNodes
            </a>
          </li>
          <li>
            <a href="/claim-address" className="hover:underline flex items-center">
              <FaHandshake className="mr-1" /> Claim Address
            </a>
          </li>
          <li>
            <a href="/peerinfo" className="hover:underline flex items-center">
              <FaNetworkWired className="mr-1" /> Peers
            </a>
          </li>
          <li>
            <a href="/api-docs" className="hover:underline flex items-center">
              <FaBook className="mr-1" /> API Docs
            </a>
          </li>
          <li>
            <a href="https://menelik.cc/" className="hover:underline flex items-center">
              <FaGlobe className="mr-1" /> Official Website
            </a>
          </li>
          <li>
            <a href="https://docs.menelik.cc/" className="hover:underline flex items-center">
              <FaFileAlt className="mr-1" /> Menelik Docs
            </a>
          </li>
        </ul>

        {/* Sección de redes sociales */}
        <div className="flex space-x-4 mt-4 lg:mt-0">
          <a href="https://menelik.cc/" target="_blank" rel="noopener noreferrer" className="hover:text-white">
            <FaFacebook size={20} />
          </a>
          <a href="https://x.com/menelikcoin" target="_blank" rel="noopener noreferrer" className="hover:text-white">
            <FaTwitter size={20} />
          </a>
          <a href="https://github.com/MenelikCoin/menelik/" target="_blank" rel="noopener noreferrer" className="hover:text-white">
            <FaGithub size={20} />
          </a>
          <a href="https://discord.gg/xjDSyeD2" target="_blank" rel="noopener noreferrer" className="hover:text-white">
            <FaDiscord size={20} />
          </a>
          <a href="https://www.youtube.com/@Menelikcoin" target="_blank" rel="noopener noreferrer" className="hover:text-white">
            <FaYoutube size={20} />
          </a>
        </div>

      </div>

      <div className="text-center text-sm mt-4">
        <p>© 2025 Block Explorer. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
